const localityOf = ({ city, state, zip }) =>
  [[city, state].filter(Boolean).join(', '), zip].filter(Boolean).join(' ');

const partsOf = (value) => {
  const address = value?.address ?? value;

  if (!address) return null;

  return {
    line1: address.line1 ?? address.addressLine1,
    line2: address.line2 ?? address.addressLine2,
    locality: localityOf(address),
  };
};

export const patientAddressLines = (value) => {
  const parts = partsOf(value);

  if (!parts) return [];

  return [[parts.line1, parts.line2].filter(Boolean).join(', '), parts.locality].filter(Boolean);
};

const formatPatientAddress = (value) => patientAddressLines(value).join(', ');

export default formatPatientAddress;
